@switch (type()) { @case ('switch') { @if (!!inline()) {
<label>
  {{ label() | translate }}
  <ng-template [ngTemplateOutlet]="rowLabelOutlet"></ng-template>
</label>
}
<div class="fx-row fx-align-center fx-gap">
  <div class="fx-inline">
    <ng-container [ngTemplateOutlet]="contentOutlet"></ng-container>
  </div>
  @if (!inline()) {
  <label>
    {{ label() | translate }}
    <ng-template [ngTemplateOutlet]="rowLabelOutlet"></ng-template>
  </label>
  }
</div>
} @case ('radio') {
<label>
  {{ label() | translate }}
  <ng-template [ngTemplateOutlet]="rowLabelOutlet"></ng-template>
</label>
<div class="fx-column radio-options">
  <ng-container [ngTemplateOutlet]="contentOutlet"></ng-container>
</div>
} @case ('text') {
<label>
  {{ label() | translate }}
  <ng-template [ngTemplateOutlet]="rowLabelOutlet"></ng-template>
</label>
<div class="fx-row">
  <ng-container [ngTemplateOutlet]="contentOutlet"></ng-container>
</div>
} @case ('button') {
<ng-container [ngTemplateOutlet]="contentOutlet"></ng-container>
} @case ('card') {
<ng-container [ngTemplateOutlet]="contentOutlet"></ng-container>
} @default {
<av-card type="warning">
  <av-card-body size="xs"
    >av-control-row: Unsupported or missing type</av-card-body
  >
</av-card>
} } @if (!!help()) {
<div class="type-{{ type() }}-help">
  <small class="text-muted">
    {{ help() | translate }}
  </small>
</div>
} @if (isHelpProjected) {
<div class="type-{{ type() }}-help-projected help-projected">
  <small class="text-muted">
    <ng-content select="[row-help]"></ng-content>
  </small>
</div>
}

<ng-template #rowLabelOutlet>
  <ng-content select="[row-label]"></ng-content>
</ng-template>

<ng-template #contentOutlet>
  <ng-content></ng-content>
</ng-template>
